import { getStyles } from './referralStyles';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';

export const renderPriorBox = (data, theme, small = false) => {
    const styles = getStyles(theme);
    if (['urgent', 'emergency', 'routine'].includes(data?.priority?.toLowerCase() || '')) {
        const priorityStyle = data?.priority?.toLowerCase();
        return (
            <Box sx={{ ...styles.priorityCell[priorityStyle], ...styles.priorityCell.common, ...(small ? styles.priorityCell.small : {}) }}>
                <Typography>{data?.priority || 'Routine'}</Typography>
            </Box>
        );
    }
};
